export var ExpressionType;
(function (ExpressionType) {
    /**  An addition operation, such as a + b, without overflow checking, for numeric operands.*/
    ExpressionType[ExpressionType["Add"] = 1] = "Add";
    /**  A conditional AND operation that evaluates the second operand only if the first operand evaluates to true. It corresponds to (a && b) in C# and (a AndAlso b) in Visual Basic.*/
    ExpressionType[ExpressionType["AndAlso"] = 2] = "AndAlso";
    /** A method call, such as in the obj.sampleMethod() expression.*/
    ExpressionType[ExpressionType["Call"] = 3] = "Call";
    /** A node that represents a null coalescing operation, such as (a ?? b) in C# or If(a, b) in Visual Basic.*/
    ExpressionType[ExpressionType["Coalesce"] = 4] = "Coalesce";
    /**  A constant value.*/
    ExpressionType[ExpressionType["Constant"] = 5] = "Constant";
    /**  A division operation, such as (a / b), for numeric operands.*/
    ExpressionType[ExpressionType["Divide"] = 6] = "Divide";
    /**  A node that represents an equality comparison, such as (a == b) in C# or (a = b) in Visual Basic.*/
    ExpressionType[ExpressionType["Equal"] = 7] = "Equal";
    /**  A bitwise or logical XOR operation, such as (a ^ b) in C# or (a Xor b) in Visual Basic.*/
    ExpressionType[ExpressionType["ExclusiveOr"] = 8] = "ExclusiveOr";
    /**  A "greater than" comparison, such as (a > b).*/
    ExpressionType[ExpressionType["GreaterThan"] = 9] = "GreaterThan";
    /**  A "greater than or equal to" comparison, such as (a >= b).*/
    ExpressionType[ExpressionType["GreaterThanOrEqual"] = 10] = "GreaterThanOrEqual";
    /**  A "less than" comparison, such as (a < b).*/
    ExpressionType[ExpressionType["LessThan"] = 11] = "LessThan";
    /**  A "less than or equal to" comparison, such as (a <= b).*/
    ExpressionType[ExpressionType["LessThanOrEqual"] = 12] = "LessThanOrEqual";
    /**  An operation that reads from a field or property, such as obj.SampleProperty.*/
    ExpressionType[ExpressionType["MemberAccess"] = 13] = "MemberAccess";
    /**  An arithmetic remainder operation, such as (a % b) in C# or (a Mod b) in Visual Basic.*/
    ExpressionType[ExpressionType["Modulo"] = 14] = "Modulo";
    /**  A multiplication operation, such as (a * b), without overflow checking, for numeric operands.*/
    ExpressionType[ExpressionType["Multiply"] = 15] = "Multiply";
    /** An arithmetic negation operation, such as (-a). The object a should not be modified in place.*/
    ExpressionType[ExpressionType["Negate"] = 16] = "Negate";
    /** An inequality comparison, such as (a != b) in C# or (a <> b) in Visual Basic.*/
    ExpressionType[ExpressionType["NotEqual"] = 17] = "NotEqual";
    /**  A short-circuiting conditional OR operation, such as (a || b) in C# or (a OrElse b) in Visual Basic.*/
    ExpressionType[ExpressionType["OrElse"] = 18] = "OrElse";
    /**  A mathematical operation that raises a number to a power, such as (a ^ b) in Visual Basic.*/
    ExpressionType[ExpressionType["Power"] = 19] = "Power";
    /** A subtraction operation, such as (a - b), without overflow checking, for numeric operands.*/
    ExpressionType[ExpressionType["Subtract"] = 20] = "Subtract";
    /** A true condition value.*/
    ExpressionType[ExpressionType["IsTrue"] = 21] = "IsTrue";
    /** A false condition value.*/
    ExpressionType[ExpressionType["IsFalse"] = 22] = "IsFalse";
})(ExpressionType || (ExpressionType = {}));
